import { Can } from '@/components/permissions-provider.tsx'
import { RsyncAllWorksButton } from '@/components/rsync-all-works-button.tsx'
import { SyncNotionButton } from '@/components/sync-notion-button.tsx'
import { ScrappingFilters } from '@/routes/_app/syncs/-components/scrapping-filter.tsx'
import { SyncTableLoading } from '@/routes/_app/syncs/-components/sync-table-loading.tsx'
import { SyncTable } from '@/routes/_app/syncs/-components/sync-table.tsx'
import { createFileRoute } from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { Suspense } from 'react'
import { z } from 'zod'

export const syncFiltersParamsPageSchema = z.object({
  page: fallback(z.coerce.number(), 1),
  filter: fallback(z.enum(['PENDING', 'SUCCESS', 'PENDING', 'FAILED', 'IDLE']).nullable(), null),
  search: fallback(z.string().nullable(), ''),
})

export const Route = createFileRoute('/_app/syncs/')({
  component: ScrappingReport,
  validateSearch: zodValidator(syncFiltersParamsPageSchema),
  head: () => ({
    meta: [
      {
        title: 'Sincronizações | Okami',
      },
    ],
  }),
})

function ScrappingReport() {
  return (
    <div className="flex  flex-col gap-4">
      <div className="flex justify-center md:justify-start">
        <h1 className="text-center text-3xl font-bold tracking-tighter md:text-left">Sincronizações</h1>
      </div>

      <header className="flex  flex-col-reverse justify-center  md:flex-row md:justify-between">
        <ScrappingFilters />

        <div className="flex flex-col items-center  justify-center gap-2 md:flex-row">
          <Can I="show" a="sync-notion-button">
            <SyncNotionButton />
          </Can>

          <Can I="show" a="rsync-works-button">
            <RsyncAllWorksButton />
          </Can>
        </div>
      </header>

      <Suspense fallback={<SyncTableLoading />}>
        <SyncTable />
      </Suspense>
    </div>
  )
}
